import { ColoursObj } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { useSectionV2Context } from "../../state/sectionProvider";
import { publicColour } from "../../v2Utils";

interface IBaseCardProps {
  id?: string;
  children?: React.ReactNode;
  past?: boolean;
  onClick?: () => void;
  borderStyle?: string;
}

export const BaseCard: React.FC<IBaseCardProps> = ({ id, children, past, onClick, borderStyle }) => {
  const { isPublic } = useSectionV2Context();

  const border = useMemo(() => {
    if (borderStyle) return borderStyle;
    if (isPublic) return `2px solid ${publicColour}`;
    return "none";
  }, [isPublic, borderStyle]);
  return (
    <Stack
      id={id + "CardId"}
      onClick={onClick}
      sx={{
        overflow: "hidden",
        bgcolor: past ? ColoursObj.shades.shade4 : ColoursObj.backgrounds.secondary,
        borderRadius: "8px",
        border: border,
        boxShadow: "1px 4px 7px rgba(10, 31, 65, 0.1)",
        marginTop: "12px"
      }}>
      <Stack
        sx={{
          padding: "8px 8px",
          gap: "8px"
        }}>
        {children}
      </Stack>
    </Stack>
  );
};
